import { render } from "./ProgrammaLavoroDetail.vue?vue&type=template&id=d64bfdf2&scoped=true"
import script from "./ProgrammaLavoroDetail.vue?vue&type=script&lang=js"
export * from "./ProgrammaLavoroDetail.vue?vue&type=script&lang=js"

import "./ProgrammaLavoroDetail.vue?vue&type=style&index=0&id=d64bfdf2&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_save-group_1779204252500559514/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d64bfdf2"]])

export default __exports__